import React from "react";
import "./home.css";
import Homediscover from "../homediscover/homediscover"
import Hometours from "../hometours/hometours"
import Homeaboutus from "../homeaboutus/homeaboutus"
import Homegallery from "../homegallery/homegallery"
import Homereview from "../homereview/homereview"
import Homeget from "../homeget/homeget"

const Home = () =>{
    return (
    <div className="main">

            <Homediscover />
            <Hometours />
            <Homeaboutus />
            <Homegallery />
            <Homereview />
            <Homeget />
       
    </div>
    )
}


export default Home;